/* eslint-disable @ngrx/prefix-selectors-with-select */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPatientResults from '../reducer/patient-result.reducer';

export const patientResultsFeatureSelector = createFeatureSelector<fromPatientResults.PatientResultsState>(
  fromPatientResults.patientResultsFeatureKey
);

const { selectEntities, selectAll } = fromPatientResults.patientResultsAdapter.getSelectors();

export const selectPatientResultEntities = createSelector(patientResultsFeatureSelector, selectEntities);

export const selectPatientResults = createSelector(patientResultsFeatureSelector, selectAll);

export const selectPatientResultCount = createSelector(selectPatientResults, results => results.length);

export const selectError = createSelector(patientResultsFeatureSelector, state => state.baseState.error);

/**
 * The single-result detail read's failure, deliberately separate from `selectError` so it cannot make
 * the results list claim it failed. See PatientResultsState.detailError.
 */
export const selectDetailError = createSelector(patientResultsFeatureSelector, state => state.detailError ?? null);

export const selectIsLoading = createSelector(patientResultsFeatureSelector, state => state.baseState.isLoading);

export const selectPageNumber = createSelector(patientResultsFeatureSelector, state => state.baseState.pageNumber);

export const selectPageSize = createSelector(patientResultsFeatureSelector, state => state.pageSize);

export const selectPatientResultsFilters = createSelector(patientResultsFeatureSelector, state => state.filters);

export const selectIsAtEndOfData = createSelector(
  patientResultsFeatureSelector,
  state => state.baseState.isAtEndOfData
);

export const selectTotalRecordCount = createSelector(
  patientResultsFeatureSelector,
  state => state.baseState.totalRecordCount
);

export const selectLastViewedResultId = createSelector(
  patientResultsFeatureSelector,
  state => state.lastViewedResultId
);

export const selectListScrollTop = createSelector(patientResultsFeatureSelector, state => state.listScrollTop);

export const selectPatientResultById = (patientLabResultId: number) =>
  createSelector(selectPatientResults, entities => {
    const result = entities.find(f => f.patientLabResultId === patientLabResultId);
    return result === undefined ? null : result;
  });
